var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"2"}},[_c('b-form-group',{staticClass:"mb-0"},[_c('label',{staticClass:"d-none d-md-block"},[_vm._v(" ")]),_c('b-button',{attrs:{"variant":"primary","block":""},on:{"click":_vm.getReport}},[_vm._v(" "+_vm._s(_vm.$t('get_report'))+" ")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }